<script scoped>
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        ph_kode: "",
        ph_name: "",
        ph_id_pohon_bisnis: null,
        ph_id: null,
      },
      dahanProfesiOption: [],
    };
  },
  props: ["typeTrans", "dataProfesi"],
  watch: {
    dataProfesi: function (newVal) {
      if (newVal == null) {
        this.formData = {
          ph_kode: "",
          ph_name: "",
          ph_id_pohon_bisnis: null,
          ph_id: null,
        };
      } else {
        this.formData = {
          ph_kode: newVal.ph_kode,
          ph_name: newVal.ph_name,
          ph_id_pohon_bisnis: newVal.ph_id_pohon_bisnis,
          ph_id: newVal.ph_id,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/pohon-profesi"
          : `master/pohon-profesi/${this.formData.ph_id}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (
        this.formData.ph_kode === "" ||
        this.formData.ph_name === "" ||
        !this.formData.ph_id_pohon_bisnis
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
    async searchDahanProfesi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getDahanProfesi(search, loading);
      }
    },
    async getDahanProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/pohon-bisnis/all",
          {
            params: {
              search: search,
              limit: 20,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.dahanProfesiOption = response.data.data;
          if (loading) loading(false);
        });
    },
  },
  mounted() {
    this.getDahanProfesi();
    this.filterDahanProfesi = _.debounce(
      this.searchDahanProfesi.bind(this),
      500
    );
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kodeProfesi" class="form-label">Kode Pohon Profesi</label>
        <input
          type="text"
          v-model="formData.ph_kode"
          class="form-control"
          id="kodeProfesi"
          placeholder="Kode Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="namaProfesi" class="form-label">Nama Pohon Profesi</label>
        <input
          type="text"
          v-model="formData.ph_name"
          class="form-control"
          id="namaProfesi"
          placeholder="Nama Profesi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="Keterangan" class="form-label">Pohon Bisnis</label>
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="dahanProfesiOption"
          :reduce="(item) => item.pb_id"
          label="pb_name"
          v-model="formData.ph_id_pohon_bisnis"
          placeholder="Pohon Bisnis"
          @search="filterDahanProfesi"
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
